export default {
    "messages":{
        "en":{
            "back":"Back",
                "login":{
                    "header":"Login",
                    "sign_in":"Sign In to your account",
                    "email_required":"email is required",
                    "password_required":"Password is required",
                    "button_login":"Login",
                    "forgot_password":"Forgot password?",
                    "register":"Register Now!",
                    "register_information_header":"NutHub",
                    "register_information_subheader":"The most advanced nutrition center in collaboration with medical experts and suppliers of health products.",
                    "register_information_line1":"Easily create menus, use food calculators, Make video calls, Enjoy customers management",
                    "register_information_line2":"Send email from your account to one or all customers, updated meeting diary activity history for each customer",
                    "register_information_line3":"Automatic BMI/BMR for each client, common diets, tables",
                    "register_information_line4":"Medical experts at your customers disposal. Your own private store",
                    "register_information_line5": "Free with no monthly subscription fees",
                    "register_information_line6": "NutHub is FREE. Free means Free. Forever."
                },
                "register":{
                    "header": "Register",
                    "create_account": "Create your account",
                    "firstname_required": "First name is required",
                    "lastname_required": "Last name is required",
                    "email_required": "Email is required",
                    "password_required": "Password is required",
                    "same_as": "Must be same as password",
                    "firstname": "First name",
                    "lastname": "Last name",
                    "email": "Email",
                    "password": "Password",
                    "repeat_password": "Repeat password",
                    "button_create_account": "Create Account"
                },
            "nav":{
                "home":"Home",
                "account_settings":"Account Settings",
                "calendar":"Calendar",
                "client_list":"Client List",
                "add_client":"Add Client",
                "menus":"Menus",
                "createmenu":"Create Menu",
                "singleclient":"SingleClient",
                "bmi":"BMI",
                "specialists":"Specialists",
                "your_shop":"Your Shop",
                "shop":"My Shop",
                "sales":"Sales",
                "help":"Help",
                "about_us":"About Us",
                "send_email" : "Send Emails",
                "all_menus" : "All Menus",
                "calculators" : "Calculators",
                "diets" : "Diets",
                "create_menu" : "Create Menu",
                "orders" : "Orders",
                "all_weeks": "Weeks",
                "create_week": "Create Week",
                "date_selected": "התאריך שנבחר",
            },
            "specialist":{
                "email": "Email",
                "name": "Name",
                "speciality": "Specialty",
                "speciality_iw": "Specialty",
                "address": "Address",
                "work": "Work",
                "phone": "Phone",
                "info": "Info",
                "commission": "Commission",
                "degree": "Degree",
                "category": "Category",
                "category_iw": "Category",
                "images": "Images",
                "profile": "Profile",
                "description": "More Information",
                "links": "Links",
                "select_category": "Select"
            },
            "weeks": {
                "add_week": "Add new week",
                "title": "Title",
                "week_start": "Week start",
                "week_end": "Week end",
                "week_created_successfully": "Week successfully added",
                "error_adding_week": "Error adding week",
                "title_is_required": "Title is required",
                "week_start_is_required": "Week start date is required",
                "week_end_is_required": "Week end date is required",
                "delete": "Are you sure that you want to delete this week?",
                "deleted_success": "Week successfully deleted",
                "edit_week": "Edit week",
                "week_updated_successfully": "Week successfully updated",
                "error_updating_week": "Error updating week",
                "select_week": "Select week",
                "date_selected": "Date selected",
                "required_fields_error": "Client field, day field & week field are required"
            },
            "menu":{
                "menu": "Menu",
                "info": "Information",
                "menu_id": "Menu Id",
                "client": "Client",
                "problems": "Problems",
                "stats": "Stats",
                "source": "Source",
                "meal": "Meal",
                "serving_size": "Serving Size",
                "serving_weight": "Serving Weight",
                "no_meals": "No meals inserted",
                "created_menu": "Created Menu",
                "foods": "Foods",
                "generate_menu": "Generate a menu for the client",
                "generate_menu_button": "Generate Menu",
                "pick_menu": "Pick Menu Template",
                "client_menus": "Client Menus",
                "meals":"Meals",
                "print": "Print",
                "email_to_client": "Email To Client",
                "menu_emailed_success": "Menu Emailed Successfully",
                "show_card": "Show Card",
                "show_table": "Show Table",
                "generated_menu": "Generated Menu",
                "created_at": "Created_at",
                "nutritionist": "Nutritionist",
                "manual_created": "Manual Created Menu",
                "meal_type": "Meal Type",
                "create_menu": "Create your Menu",
                "select_client": "Select Client",
                "choose_meal": "Choose Meal",
                "breakfast": "Breakfast",
                "brunch": "Brunch",
                "lunch":"Lunch",
                "afternoon":"Afternoon",
                "dinner":"Dinner",
                "goodnight":"Goodnight",
                "select_food_type": "Select Food Type",
                "search_food":"Search Food",
                "create_custom_food": "Create custom Food",
                "meals_created": "Meals created",
                "select_meal": "Select Foods for the meal",
                "details": "Details",
                "energy": "Energy (calories)",
                "size": "Basic Size (gram)",
                "more_details": "More Details",
                "meal_foods_selected": "Meal foods selected for",
                "day": "Day",
                "save_menu_button": "Save Menu to client page",
                "save_and_share": "Save and share with client",
                "payment_needed": "Payment is needed for this client",
                "add_another_meal": "Save and create another meal",
                "delete": "Are you sure you want to delete this menu?",
                "yes": "Yes",
                "no": "No",
                "deleted_success": "Menu deleted successfully",
                "create_food_category": "Create food type",
                "qty": "Quantity",
                "serving": "Serving",
                "select_diet": "Select Diet",
                "update_menu": "Update Menu",
                "select_menu_diet" : "Select a diet for this client",
                "select_client_to_create_menu" : "Select the client for which you are creating this menu",
                "select_daily_meal" : "Select the daily meal",
                "select_food_type_menu" : "Select the type of food for the meal",
                "create_custom_food_for_menu" : "When pressing this button you can create a new custom food based on the meal that you have chosen and the client needs.",	
                "create_menu_food_type" : "When pressing this button you can create a new food type for this menu",
                "limit_reached" : "The client selected has reached the daily limit calories for the day selected, are you sure you want to continue?",
                "total_calories_for" : "Total calories for",
                "create_first_menu" : "Create your first Menu",
                "go_to_dashboard": "For more go to your dashboard - click here"
            },
            "profile":{
                "account_image": "Account Image",
                "upload_image": "Upload Image",
                "account_settings": "Account Settings",
                "id": "Id",
                "parent_user": "Parent User",
                "first_name": "Enter your first name",
                "first_name_description": "Let us know your first name.",
                "last_name": "Enter your last name",
                "last_name_description": "Let us know your last name.",
                "resident_id": "Resident Id",
                "gender": "Gender",
                "address": "Country",
                "please_select": "Please select",
                "email": "Email Input",
                "email_desc": "Please enter your email",
                "created_at": "Created_at",
                "update": "Update",
                "profile_updated": "Profile Updated",
                "pofile_image_updated": "Profile Image Updated",
                "whatsapp_nr": "WhatsApp No",
                "select_gender": "Please select gender",
                "data_missing": "There are some missing information, please insert the information below to enable the system.",
                "can_show" : "Do you want new clients to contact you?",
                "max_image": "Image - MAX 1MB",
                "image_tip": "if you can't see the image please refresh the page - click F5",
                "activate_account": "Activate your Account"
            },
            "dashboard":{
                "last_days": "Last 7 Days",
                "clients": "Clients",
                "new_clients": "New Clients",
                "menus": "Menus",
                "new_menus": "New Menus",
                "meetings": "Meetings",
                "new_meetings": "New Meetings",
                "sales": "Sales",
                "new_sales": "New Sales",
                "greetings" : "Hello",
                "subtitle" : 'Tip: Not sure how to create a menu? watch the video in the ``how-to page"  title.',
                "start_by":"Start by create menu, to limit your calories check the calorie calculator and then create menu by limit calories",
                "learn_about_diets" : "Learn about popular diets",
            },
            "calendar":{
                "add_event": "Add New Event",
                "add_event_title": "Add a new Event",
                "update_event_title": "Update Event",
                "date_from": "Date From",
                "date_to": "Date To",
                "client": "Client",
                "title": "Enter title",
                "short_desc": "Enter a short description",
                "description": "Enter a description",
                "event_added_success": "Event Added Successfully",
                "event_added_error": "Event Not added",
                "event_updated_success": "Event Updated Successfully",
                "event_updated_error": "Event Not Updated",
                "type": "Event Type",
                "on_person": "In Person",
                "videocall": "On WhatsApp",
                "general": "General",
                "delete" : "Delete",
                "event_deleted_success" : "Event Deleted Successfully",
                "event_deleted_error" : "Event Not Deleted"
            },
            "client":{
                "refresh": "Refresh",
                "show_card": "Show Card",
                "show_table": "Show Table",
                "search": "Search",
                "email": "Email",
                "phone_number": "Phone Number",
                "calendar_events": "Calendar Events",
                "menus": "Menus",
                "private_notes": "Private Notes",
                "notes": "Notes",
                "parent_user": "Parent User",
                "first_name": "Enter your first name",
                "first_name_description": "Let us know your first name.",
                "last_name": "Enter your last name",
                "last_name_description": "Let us know your last name.",
                "id": "Identification",
                "gender": "Gender",
                "address": "Address",
                "please_select": "Please select",
                "birthday": "Birthday",
                "height": "Height",
                "weight": "Weight",
                "submit": "Submit",
                "client_added_success": "Client Added Successfully",
                "client_added_error": "Error when adding client",
                "client_events": "Client Events",
                "update_client_info": "Update Client Info",
                "start": "Start",
                "end": "End",
                "subject": "Subject",
                "contentFull": "ContentFull",
                "event": "Event",
                "add_note_for_client": "Add Note for client",
                "note": "Note",
                "add_note": "Add Note",
                "title": "Title",
                "description": "Description",
                "client_added_successfully": "Client Added Successfully",
                "client_note_added_successfully": "Client Note Added Successfully",
                "client_refere": "Refer client to Medical Specialist",
                "pick_specialist": "Pick Specialist",
                "client_refer_button": "Refer Client",
                "past_references": "Past references",
                "specialist": "Specialist",
                "refered_at": "Referred at",
                "commision": "Commission",
                "specialist_not_selected": "Specialist not selected",
                "client_refered_successfull": "Client successfully referred",
                "refer_specialist": "Refer client to a specialist",
                "send":"Send",
                "full_name": "Name",
                "date":"Date",
                "max_cals" : "Maximum daily calories",
            },
            "shop": {
                "total_payed": "Total Paid:",
                "add_to_cart": "Add to Cart",
                "select_client":"Please Select Client",
                "commission": "Commission",
                "price": "Price",
                "delivery_price": "Delivery Price"
            },
            "order":{
                "order_id": "Order ID",
                "transaction_id": "Transaction",
                "payment_method": "Payment Method",
                "currency": "Currency",
                "total": "Total Amount",
                "created_at": "Created At",
                "client": "Client",
                "commission": "Commission"
            },
            "diets": {
                "name": "Diet Name",
                "text": "Diet Information"
            },
            "history":{
                "create_referal": "Created Referral",
                "create_menu": "Created Menu",
                "delete_menu": "Deleted Menu",
                "create_client": "Created Client",
                "update_client": "Updated Client",
                "create_event": "Created Event",
                "update_event": "Updated Event",
                "buy_products": "Shop Products Purchased",
                "create_client_note": "Created Client Note"
            }
        },
        "iw": {
            "login": {
                "header": "התחבר",
                "sign_in": "התחבר לחשבונך",
                "email_required": "נדרש דואר אלקטרוני",
                "password_required": "נדרשת סיסמה",
                "button_login": "התחבר",
                "forgot_password": "שכחת סיסמה?",
                "register": "הרשם עכשיו!",
                "register_information_header": "NutHub",
                "register_information_subheader": "המרכז הגדול והמתקדם לתזונה נכונה",
                "register_information_line1": "בשיתוף תזונאים ודיאטנים, מאמני תזונה, מומחים רפואיים וספקי מוצרי בריאות ",
                "register_information_line2": " חינם ללא מנוי חודשי",
                "register_information_line3": " דיאטות נפוצות, טבלאות BMI BMR, פריטי מזון עם ערכים מפורטים מה USDA ",
                "register_information_line4": " מומחים רפואיים , חנות פרטית משלך",
                "register_information_line5": " יצור תפריטים בקלות, מחשבוני מזון, היסטוריה, פורום, קשר ישיר עם תזונאים ",
                "register_information_line6": "שיחות וידאו עם תזונאים, דיאטנים ומאמני תזונה כולל רופאים וגולשים אחרים - והכל חינם"
            },
            "register":{
                "header": "הירשמו גם אתם",
                "create_account": "צור חשבון",
                "firstname_required": "דרוש שם פרטי",
                "lastname_required": "דרוש שם משפחה",
                "email_required": "דרוש אימייל",
                "password_required": "דרושה סיסמה",
                "same_as": "סיסמה חייבת להיות זהה",
                "firstname": "שם פרטי",
                "lastname": "שם משפחה",
                "email": "אימייל",
                "password": "סיסמה",
                "repeat_password": "חזור על הסיסמה",
                "button_create_account": "צור חשבון"
            },
            "nav":{
                "home":"כללי",
                "account_settings":"הגדרות חשבון",
                "calendar":"יומן",
                "client_list":"רשימת לקוחות",
                "add_client":"הוסף לקוח",
                "menus":"כל התפריטים",
                "createmenu":"צור תפריט",
                "singleclient":"לקוח",
                "bmi":"BMI",
                "specialists":"מומחים רפואים",
                "your_shop":"החנות שלך",
                "shop":"החנות שלך",
                "sales":"מכירות",
                "help":"מאמרים ומידע",
                "about_us":"קצת עלינו",
                "send_email" : "Send Emails",
                "all_menus" : "All Menus",
                "calculators" : "Calculators",
                "diets" : "Diets",
                "create_menu" : "Create Menu",
                "orders" : "Orders",
                "all_weeks": "Weeks",
                "create_week": "Create Week",
                "date_selected": "התאריך שנבחר",
            },
            "specialist":{
                "email": "אימייל",
                "name": "שם",
                "speciality": "תחום התמחות",
                "speciality_iw": "תחום התמחות",
                "address": "כתובת מלאה",
                "work": "עבודה/ קליניקה",
                "phone": "טלפון",
                "info": "מידע כללי"
            },
            "weeks": {
                "add_week": "Add new week",
                "title": "Title",
                "week_start": "Week start",
                "week_end": "Week end",
                "week_created_successfully": "Week successfully added",
                "error_adding_week": "Error adding week",
                "title_is_required": "Title is required",
                "week_start_is_required": "Week start date is required",
                "week_end_is_required": "Week end date is required",
                "delete": "Are you sure that you want to delete this week?",
                "deleted_success": "Week successfully deleted",
                "edit_week": "Edit week",
                "week_updated_successfully": "Week successfully updated",
                "error_updating_week": "Error updating week",
                "select_week": "Select week",
                "date_selected": "Date selected",
                "required_fields_error": "Client field, day field & week field are required"
            },
            "menu":{
                "menu": "תפריט",
                "info": "מידע כללי",
                "menu_id": "מזהה תפריט",
                "client": "לקוח",
                "problems": "בעיות",
                "stats": "נתונים סטטיסטיים",
                "source": "מקור",
                "meal": "ארוחה",
                "serving_size": "גודל מנה",
                "serving_weight": "משקל מנת הגשה",
                "no_meals": "לא הוכנסו ארוחות",
                "created_menu": "התפריט שנוצר",
                "foods": "מזון",
                "generate_menu": "צור/י תפריט ללקוח",
                "generate_menu_button": "צור/י תפריט",
                "pick_menu": "בחר תבנית תפריט",
                "client_menus": "תפריטי הלקוח",
                "meals":"ארוחות",
                "print": "הדפסה",
                "email_to_client": "שלח באימייל ללקוח",
                "menu_emailed_success": "התפריט נשלח באימייל בהצלחה",
                "show_card": "הצג בכרטיסים",
                "show_table": "הצג בטבלה",
                "generated_menu": "תפריט שנוצר",
                "created_at": "נוצר בתאריך",
                "nutritionist": "תזונאית",
                "manual_created": "נוצר תפריט ידני",
                "meal_type": "סוג ארוחה",
                "create_menu": "צור/י את התפריט",
                "select_client": "בחר לקוח",
                "choose_meal": "בחר ארוחה",
                "breakfast": "ארוחת בוקר",
                "brunch": "בְּרַנְץ",
                "lunch":"ארוחת צהריים",
                "afternoon":"ארוחת ארבע",
                "dinner":"ארוחת ערב",
                "goodnight":"ארוחת לילה",
                "select_food_type": "בחר/י סוג מזון",
                "search_food":"חפש מזון",
                "create_custom_food": "צור פריט מזון חדש",
                "meals_created": "הארוחה נוצרה",
                "select_meal": "בחר/י סוגי מזון עבור הארוחה",
                "details": "פרטים",
                "energy": "אנרגיה (קלוריות)",
                "size": "גודל בסיס (בגרם)",
                "more_details": "פרטים בפרוטרוט",
                "meal_foods_selected": "פריטי מזון שנבחרו עבור",
                "day": "יום",
                "save_menu_button": "שמור תפריט בדף הלקוח",
                "save_and_share": "שמור ושתף עם הלקוח",
                "payment_needed": "נדרש תשלום עבור לקוח זה",
                "add_another_meal": "שמור והוסף ארוחה לתפריט",
                "create_food_category": "צור סוג מזון",
                "qty": "כמות",
                "serving": "יחידת הגשה",
                "select_diet": "בחר דיאטה",
                "update_menu": "עדכן תפריט",
                "select_menu_diet" : "בחר סוג דיאטה ללקוח זה",
                "select_client_to_create_menu" : "בחר את הלקוח עבורו אתה מכין את התפריט",
                "select_daily_meal" : "בחר ארוחה",
                "select_food_type_menu" : "בחר את סוג המזון עבור הארוחה שבחרת",
                "create_custom_food_for_menu" : "בלחיצה על כפתור זה תוכלו ליצור סוג אוכל חדש בהתאמה אישית על פי הארוחה שבחרתם וצרכי הלקוח.",
                "create_menu_food_type" : "בלחיצה על כפתור זה תוכלו ליצור סוג אוכל חדש לתפריט זה",
                "limit_reached": "הלקוח שנבחר הגיע למגבלת הקלוריות היומית ליום שנבחר, האם אתה בטוח שברצונך להמשיך?",
                "total_calories_for" : 'סה"כ קלוריות עבור',
                "create_first_menu" : "צור את התפריט הראשון שלך",
                "go_to_dashboard": "למידע נוסף היכנסו למרכז השליטה שלכם - לחצו כאן"
            },
            "profile":{
                "account_image": "תמונת חשבון",
                "upload_image": "העלה תמונה",
                "account_settings": "הגדרות חשבון",
                "id": "מזהה",
                "parent_user": "משתמש ראשי",
                "first_name": "הכנס שם פרטי",
                "first_name_description": "אנא הוסף שם פרטי.",
                "last_name": "הכנס שם משפחה",
                "last_name_description": "אנא הוסף שם משפחה.",
                "resident_id": "מספר תעודת זהות",
                "gender": "מין",
                "address": "כתובת",
                "please_select": "אנא בחר/י",
                "email": "הכנס אימייל",
                "email_desc": "אנא רשום את האימייל שלך",
                "created_at": "נוצר_בתאריך",
                "update": "עדכן",
                "profile_updated": "הפרופיל עודכן",
                "pofile_image_updated": "תמונת הפרופיל עודכנה",
                "whatsapp_nr": "מספר טלפון לשיחות ווטסאפ",
                "select_gender": "אנא בחר מין ז/נ",
                "data_missing": "המידע עדיין לא הושלם אנא השלם את הפרטים הדרושים על מנת להפעיל את המערכת .",
                "can_show" : "האם אתה מעוניין שלקוחות חדשים יצרו איתך קשר?",
                "max_image": "תמונה - MAX 1MB",
                "image_tip": "אם אינך יכול לראות את התמונה אנא רענן את הדף - לחץ על F5",
                "activate_account": "הפעל את חשבונך"
            },
            "dashboard":{
                "last_days": "שבעה ימים אחרונים",
                "clients": "לקוחות",
                "new_clients": "לקוחות חדשים",
                "menus": "תפריטים",
                "new_menus": "תפריטים חדשים",
                "meetings": "פגישות",
                "new_meetings": "פגישות חדשות",
                "sales": "הכנסות",
                "new_sales": "מכירות חדשות",
                "greetings" : "ברוכים הבאים",
                "subtitle" : "טיפ: לא בטוחים איך להכין תפריט? צפו בסרט בדף ההדרכה ",
                "start_by":"התחל בצור תפריט, להגבלת כמות הקלוריות, עבור למחשבונים למחשבון הקלוריות ולאחר מכן צור תפריט  מוגבל בקלוריות",
                "learn_about_diets" : "למד אודות דיאטות פופולריות",
            },
            "calendar":{
                "add_event": "צור/י ארוע חדש",
                "add_event_title": "צור/י ארוע חדש",
                "update_event_title": "עדכן ארוע",
                "date_from": "מיום",
                "date_to": "עד יום",
                "client": "לקוח",
                "title": "הכנס כותרת",
                "short_desc": "הכנס תאור קצר",
                "description": "הכנס תאור ארוך",
                "event_added_success": "הארוע נוצר בהצלחה",
                "event_added_error": "הארוע לא התווסף",
                "event_updated_success": "הארוע עודכן בהצלחה",
                "event_updated_error": "הארוע לא עודכן",
                "type": "סוג הארוע",
                "on_person": "פגישה אישית",
                "videocall": "פגישה בווטסאפ",
                "general": "תזכורות לעצמי",
                "delete" : "Delete",
                "event_deleted_success" : "Event Deleted Successfully",
                "event_deleted_error" : "Event Not Deleted"
            },
            "client":{
                "refresh": "רענן",
                "show_card": "הצג כרטיס",
                "show_table": "הצג טבלה",
                "search": "חיפוש",
                "email": "אימייל",
                "phone_number": "מספר טלפון",
                "calendar_events": "אירועי לוח שנה",
                "menus": "תפריטים",
                "private_notes": "הערות פרטיות",
                "notes": "הערות",
                "parent_user": "משתמש ראשי",
                "first_name": "הכנס שם פרטי",
                "first_name_description": "הכנס כאן שם פרטי.",
                "last_name": "הכנס שם משפחה",
                "last_name_description": "הכנס כאן שם משפחה.",
                "id": "מספר תעודת זהות",
                "gender": "מין",
                "address": "כתובת",
                "please_select": "אנא בחר/י",
                "birthday": "תאריך לידה",
                "height": "גובה",
                "weight": "משקל",
                "submit": "עדכן",
                "client_added_success": "הלקוח נוסף בהצלחה",
                "client_added_error": "נוצרה שגיאה בעת הוספת הלקוח",
                "client_events": "אירועי לקוח",
                "update_client_info": "עדכן פרטי לקוח",
                "start": "התחלה",
                "end": "סיום",
                "subject": "נושא",
                "contentFull": "פרטים",
                "event": "ארוע",
                "add_note_for_client": "הוסף הערה עבור הלקוח",
                "note": "הערה",
                "add_note": "הוסף/י הערה",
                "title": "כותרת",
                "description": "תאור",
                "client_added_successfully": "הלקוח נוסף בהצלחה",
                "client_note_added_successfully": "הערה עבור הלקוח נוספה בהצלחה",
                "client_refere": "הפנה/י את הלקוח למומחה",
                "pick_specialist": "בחר/י לקוח",
                "client_refer_button": "הפנה/י לקוח",
                "past_references": "הפניות קודמות",
                "specialist": "מומחה",
                "refered_at": "הופנה בתאריך",
                "commision": "עמלה",
                "specialist_not_selected": "לא נבחר מומחה",
                "client_refered_successfull": "הלקוח הופנה בהצלחה",
                "send":"שלח",
                "full_name": "שם מלא",
                "date":"Date",
                "max_cals" : "Maximum daily calories",
            },
            "shop": {
                "total_payed": "סך הכל שולם:",
                "add_to_cart": "הוסף לעגלה",
                "select_client":"אנא בחר לקוח",
                "commission": "עמלה",
                "price": "מחיר",
                "delivery_price": "מחיר משלוח"
            },
            "order":{
                "order_id": "מספר הזמנה",
                "transaction_id": "עסקה",
                "payment_method": "אמצעי תשלום",
                "currency": "מטבע",
                "total": "סכום כולל",
                "created_at": "נוצר בתאריך",
                "client": "לקוח",
                "commission": "עמלה"
            },
            "diets": {
                "name": "סוג הדיאטה",
                "text": "מידע על הדיאטות"
            },
            "history":{
                "create_referal": "נוצרה הפניה למומחה רפואי",
                "create_menu": "תפריט נוצר",
                "delete_menu": "תפריט נמחק",
                "create_client": "לקוח נוצר",
                "update_client": "לקוח עודכן",
                "create_event": "ארוע נוצר",
                "update_event": "ארוע עודכן",
                "buy_products": "מוצרים שנרכשו",
                "create_client_note": "הערת הלקוח נוצרה"
            }
        }
    }
}